
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 21 21"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10.5","cy":"10.5","r":"10.5","fill":"#838DA6"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M6.6 9.46h7.627v6.24H6.6V9.46zm1.387 0V7.726a2.427 2.427 0 114.853 0V9.46"}}),_c('path',{attrs:{"fill":"#fff","d":"M9.374 12.58a1.04 1.04 0 102.08 0 1.04 1.04 0 00-2.08 0z"}})])
          )
        }
      }
    